import {
    CameraFilled,
    CheckSquareOutlined,
    OrderedListOutlined,
} from "@ant-design/icons";
import { AssortmentTaskType } from "tm-shared/types";

export const ASSORTMENT_SUBTASK_ICON = {
    [AssortmentTaskType.ProductsMatrix]: CheckSquareOutlined,
    [AssortmentTaskType.FinGroupPhotos]: CameraFilled,
    [AssortmentTaskType.Facings]: OrderedListOutlined,
};
